// @ts-nocheck
import React from 'react'

import styles from './Text.module.scss'

export const Text = ({ children }) => <p className={styles.text}>{children}</p>
